import React, { FC, useState } from 'react';
import { Button, Card, CardBody, CardHeader, Col, Input, Row } from 'reactstrap';
import { ProductModel } from '../../../../../shared/orders';
import { MaterialIcon } from '../../../../components';
import { Currency } from '../../../../components/Currency';
import { JSONForm } from '../../../../components/json-form/JSONForm';
import { useTranslation } from '../../../../translations';
import { useConfig } from '../../../../utils';

interface PriceInfoProps {
  readonly product: ProductModel;
  readonly onUpdate: () => void;
}

const enum PriceInfoMode {
  View,
  Edit,
}

export const PriceInfo: FC<PriceInfoProps> = ({ product, onUpdate }) => {
  const { ts } = useTranslation();
  const { currencySymbol } = useConfig();
  const [mode, setMode] = useState(PriceInfoMode.View);

  if (mode === PriceInfoMode.View) {
    return (
      <Card className="mb-10">
        <CardHeader>{ts('product.prices')}</CardHeader>
        <CardBody>
          <Row className="text-center">
            <Col xs={12}>
              <strong>{ts('current_price')}</strong>
              <h2 style={{ marginTop: '5px' }}>
                <Currency value={product.price} />
              </h2>
            </Col>
            {!product.deletedAt && (
              <Col xs={12}>
                <Button
                  block
                  color="primary"
                  id="changePrice"
                  onClick={() => {
                    setMode(PriceInfoMode.Edit);
                  }}
                  style={{ marginTop: '10px' }}
                >
                  {ts('product.change price')}
                </Button>
              </Col>
            )}
          </Row>
        </CardBody>
      </Card>
    );
  }

  return (
    <Card>
      <CardHeader>{ts('product.prices')}</CardHeader>
      <CardBody>
        <JSONForm
          method="patch"
          onSuccess={() => {
            onUpdate();
            setMode(PriceInfoMode.View);
          }}
          path={`/api/products/${product.id}/price`}
        >
          <Row className="text-center">
            <Col xs={5}>
              <strong>{ts('new_price')}</strong>
              <h2 style={{ marginTop: '5px' }}>
                <Row>
                  <Col xs={2}>{currencySymbol}</Col>
                  <Col xs={10}>
                    <Input
                      defaultValue={(product.price / 100).toFixed(2)}
                      id="price"
                      min={0}
                      name="price"
                      step={0.01}
                      style={{ fontSize: '1.25rem', marginTop: '-3px' }}
                      type="number"
                    />
                  </Col>
                </Row>
              </h2>
            </Col>
            <Col xs={2}>
              <MaterialIcon large name="arrow_back_ios" />
            </Col>
            <Col xs={5}>
              <strong>{ts('current_price')}</strong>
              <h2 style={{ marginTop: '5px' }}>
                <Currency value={product.price} />
              </h2>
            </Col>
            <Col xs={6}>
              <Button block color="primary" id="saveNewPrice" outline style={{ marginTop: '10px' }}>
                {ts('save_new_price')}
              </Button>
            </Col>
            <Col xs={6}>
              <Button
                block
                color="danger"
                onClick={() => {
                  setMode(PriceInfoMode.View);
                }}
                outline
                style={{ marginTop: '10px' }}
              >
                {ts('common.cancel')}
              </Button>
            </Col>
          </Row>
        </JSONForm>
      </CardBody>
    </Card>
  );
};
